import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import VozilaUnos from './VozilaTabs/VozilaUnos';
import VozilaPregled from './VozilaTabs/VozilaPregled';
import VozilaDokumenta from './VozilaTabs/VozilaDokumenta';
import VozilaOprema from './VozilaTabs/VozilaOprema';

const VozilaHome = () => {
  const { t } = useTranslation();

    const [changeView, setChangeView] = useState(1);
    const activeClass = 'activeButton'

return (
    <div style={{marginTop:'1%'}}>
        <Button id={changeView == 1 && activeClass} label={t('fakture.pregled')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 2 && activeClass} label={t('admin.unos')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(2)} } />
        <Button id={changeView == 3 && activeClass} label={t('admin.tabDokumenta')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(3)} } />
        <Button id={changeView == 4 && activeClass} label={t('oprema.tab')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(4)} } />

        {changeView == 1 &&  <VozilaPregled/>}
        {changeView == 2 && <VozilaUnos/>}
        {changeView == 3 && <VozilaDokumenta/>}
        {changeView == 4 && <VozilaOprema/>}
    </div>
)
}

export default VozilaHome;